// ** React Imports
import React from 'react'
import Link from 'next/link'

// ** Child Imports
import AnalyticsDataWidget from '../visualizations/AnalyticsDataWidget'
import { ArrowRight } from 'react-feather'

// ** Types Imports
import { WidgetType, EmbededLinkType } from 'src/lib/types/dashboardAnalytics'

// ** Util Imports
import { initialOrdersWidgetData, ordersWidgetsConfig } from 'src/assets/AnalyticsConfig'
import { analyticsConstants } from 'src/lib/utils/constants'

const ACRDataWidget: React.FC<WidgetType> = ({ value, isLoading, id, hasComparison, embededLinks, moreIsGood }) => {
  const currentValue = value ?? initialOrdersWidgetData?.data?.widgetData
  const currentIndex = 6

  const fontProperties = {
    fontSize: 28,
    fontWeight: 600,
    fontColor: '#4D4D4D',
    lineHeight: '36px'
  }

  const compareToFontProperties = {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '20px'
  }

  const subDetailsFontProperties = {
    fontSize: 16,
    fontWeight: 600,
    fontColor: '#4D4D4D',
    lineHeight: '20px'
  }

  const compareToFontPropertiesForSubDetails = {
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '14px'
  }

  const getMainDescription = () => {
    return `${Boolean(currentValue?.[hasComparison ? 6 : 1]?.x) ? currentValue?.[hasComparison ? 6 : 1]?.x : '0'} of ${
      Boolean(currentValue?.[hasComparison ? 5 : 0]?.x) ? currentValue?.[hasComparison ? 5 : 0]?.x : '0'
    } abandoned checkouts recovered`
  }

  return (
    <div className='flex flex-col gap-3'>
      <AnalyticsDataWidget
        hideBorders
        widgetType={ordersWidgetsConfig?.[currentIndex]?.widgetType}
        valueType={ordersWidgetsConfig?.[currentIndex]?.valueType}
        widgetWidth={'100%'}
        widgetHeight={50}
        fontProperties={fontProperties}
        value={currentValue?.[hasComparison ? 7 : 2]?.x ?? '0'}
        {...(hasComparison ? { compareToValue: currentValue?.[0]?.compare_to_x ?? '0' } : {})}
        isLoading={isLoading}
        removeInnerPadding
        cardVariant='outlined'
        moreIsGood={moreIsGood}
        description={getMainDescription()}
        compareToFontProperties={compareToFontProperties}
      />
      <div className='grid grid-cols-2 gap-2'>
        {ordersWidgetsConfig?.[currentIndex]?.subDetails?.map((detail: WidgetType, index: number) => {
          return (
            <AnalyticsDataWidget
              key={`${index}`}
              hideBorders
              widgetType={detail?.widgetType}
              valueType={detail?.valueType}
              widgetWidth={'100%'}
              widgetHeight={50}
              description={detail?.description}
              fontProperties={subDetailsFontProperties}
              value={`${currentValue?.[hasComparison ? 8 + index : index + 3]?.x}`}
              isLoading={isLoading}
              removeInnerPadding
              cardVariant='outlined'
              moreIsGood={moreIsGood}
              compareToFontProperties={compareToFontPropertiesForSubDetails}
            />
          )
        })}
      </div>

      <div className='flex flex-col pt-2'>
        {embededLinks?.map((link: EmbededLinkType, index: number) => {
          return (
            <Link key={`${link?.value}_${index}`} href={link?.value} passHref>
              <span className='flex items-center gap-1 text-sm font-semibold underline cursor-pointer decoration-2 decoration-gray-200 underline-offset-2'>
                {link?.label} <ArrowRight className='w-4 h-4 stroke-[2.5px]' />
              </span>
            </Link>
          )
        })}
      </div>
    </div>
  )
}

export default ACRDataWidget
